module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_cancellation", [["div",{"class":"content-block pad-lr pad-tb","id":"account-form"},[["div",{"class":"global-title"},[["textNode",{"text":"Cancellation"}]]],["div",{"class":"content-page cancellation-page pad-tb"},[["div",{"class":"cite"}],["div",{"class":"cancellation-form-wrapper"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/cancellation.tpl
// module id = 1207
// module chunks = 4